import React, { useEffect, useState } from 'react';

import { Router } from 'react-router';

import { createBrowserHistory } from 'history';

import { TypeApplicationStore } from '../stores/application-store';
import { injectStores } from '../stores/factories/store-utils';

import Header from '../components/menus/header/header';

import './jakhub.scss';

const history = createBrowserHistory();

const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
};

export const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        const handleResize = () => setWindowDimensions(getWindowDimensions());
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
};

export interface Props {
    ApplicationStore: TypeApplicationStore;
}

function Jakhub(props: Props) {
    const {
        ApplicationStore: { applicationIsLoaded, setViewportSize, closeMobileMenu },
    } = props;
    setViewportSize(useWindowDimensions());

    if (!applicationIsLoaded()) {
        return <div />;
    }

    return (
        <Router history={history}>
            <div className='jakhub-parent container' onClick={closeMobileMenu}>
                <Header />
            </div>
        </Router>
    );
}

export default injectStores(['ApplicationStore'])(Jakhub);
